import { useState } from "react";
import { useTranslation } from "react-i18next";
import BackgroundGradient from "@/components/landing/BackgroundGradient";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import WorkflowSection from "@/components/landing/WorkflowSection";
import PortfolioSection from "@/components/landing/PortfolioSection";
import PricingSection from "@/components/landing/PricingSection";
import AboutSection from "@/components/landing/AboutSection";
import Footer from "@/components/landing/Footer";
import ContactModal from "@/components/landing/ContactModal";
import ClientSlotsWidget from "@/components/landing/ClientSlotsWidget";
import WhatsAppButton from "@/components/WhatsAppButton";
import CookieConsent from "@/components/CookieConsent";
import SEO from "@/components/SEO";
import { FLAGS } from "@/lib/featureFlags";

const Index = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <SEO title={t("seo.home.title")} description={t("seo.home.description")} path="/" />
      <BackgroundGradient />
      <div style={{ position: "relative", zIndex: 1 }}>
        <Navbar onCTA={() => setModalOpen(true)} />
        <main>
          <HeroSection onCTA={() => setModalOpen(true)} />
          <div style={{ display: "flex", justifyContent: "center", padding: "16px var(--site-px) 32px" }}>
            <ClientSlotsWidget />
          </div>
          <PricingSection onCTA={() => setModalOpen(true)} />
          {FLAGS.showWorkSection && <PortfolioSection />}
          <WorkflowSection onCTA={() => setModalOpen(true)} />
          <TestimonialsSection />
          <AboutSection />
          <Footer />
        </main>
      </div>
      <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} />
      <WhatsAppButton />
      <CookieConsent />
    </>
  );
};

export default Index;
